export const STATUS_OPEN = 1
export const STATUS_CLOSED = 2

export const DISPLAY_OPEN = 'Open'
export const DISPLAY_CLOSED = 'Closed'
